export const REELS_SCROLL_SWITCH_COOLDOWN = 800;
export const REELS_SWIPE_THRESHOLD = 50;
export const REELS_PLAY_STATUS_INDICATOR_DURATION = 500;
export const REELS_LOCAL_VIDEOS_COUNT = 9;

export const REELS_WHEEL_SCROLL_THRESHOLD = 30;
